import { SET_DOCUMENTS, SET_DOCUMENT_TYPE } from "./constants";
import { documentos } from "../../../_services/documentos";
import { globalCatch } from "../../../_services/global-catch";
import { downloadFile } from "../../../utils";
import { TOKEN_EXPEDIENT } from "../../../constants";

export const setDocumentType = (payload) => ({
  type: SET_DOCUMENT_TYPE,
  payload,
});

export const setDocuments = (payload) => ({
  type: SET_DOCUMENTS,
  payload,
});

export const getDocumentType = (locale) =>
  globalCatch.catch(async (dispatch) => {
    const documentTypes = await (
      await documentos()
    ).getSecretaryStudentDocumentTypes();

    const excluded = {
      es: [64],
      it: [58, 85, 88, 129, 130, 131, 132, 133],
    };

    const excludedIds = excluded[locale] || [];

    const result = documentTypes
      .filter(
        (type) =>
          type.translations?.some(
            (translation) => translation.locale === locale,
          ) && !excludedIds.includes(type.id),
      )
      .map((type) => {
        const translation = type.translations.find((t) => t.locale === locale);

        return {
          ...type,
          name: translation.name,
        };
      })
      .sort((a, b) => a.name.localeCompare(b.name, locale));
    dispatch(setDocumentType(result));
  });

export const uploadDocument = (studentId, documentTypeId, file, opts) =>
  globalCatch.catch(async (dispatch) => {
    try {
      await (
        await documentos()
      ).uploadSecretaryStudentDocument(studentId, documentTypeId, file, opts);

      const documents = await (
        await documentos()
      ).getSecretaryStudentDocuments(studentId);

      dispatch(setDocuments(documents));

      return true;
    } catch (error) {
      throw error;
    }
  });

export const getDocuments = (studentId) =>
  globalCatch.catch(async (dispatch) => {
    const documents = await (
      await documentos()
    ).getSecretaryStudentDocuments(studentId);
    dispatch(setDocuments(documents));
  });

export const downloadDocument = (studentId, docId, fileName) => {
  return downloadFile({
    url: `${micuentaenv.STUDENT_ACCOUNT_API_basePath}/account/secretary/student-documents/student/${studentId}/documents/${docId}/download`,
    fileName,
    TOKEN: TOKEN_EXPEDIENT,
  });
};
